import { Injectable } from '@angular/core';
import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import {BsToastService} from '../Services/bs-toast-service';
import {AuthService} from '../Services/auth.service';
import { Router } from '@angular/router';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  constructor(
    private authUser: AuthService,
    private notification: BsToastService,
    private router: Router
  ) {}

  errStatus: any;
  private lastErrorTrapped = '';
  private lastErrorDateTime = '';
  private lastErrorUrl = '';
  errStatusText: any;
  errText: any;
  errDesc: any;
  errData: any;
  errMsgLog: string;
  errMsgScreen: string;
  errUrl: string;
  errMessage: string;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const { url, method, headers, body } = request;
    // console.log('hdr from interceptor:' + JSON.stringify(headers));
    // console.log('method from interceptor:' + JSON.stringify(method));
    // console.log('request.body from interceptor:' + JSON.stringify(request.body));

    let handled = false;
    return next.handle(request).pipe(
      tap((evt) => {
        // console.log('I am an evt item: ', evt);
        // console.log('request: ' , request);
        if (evt instanceof HttpResponse) {
          // console.log('i am the httpResponse: ', evt);
          if (evt.url.includes('activityfeed') || (evt.url.includes('email') && evt.body.Message === 'Preflight')) {
           // if (evt.url.includes('activityfeed')) {
            handled = true;
            return;
          }
          if ((evt.status === 200 || evt.status === 201) && request.url.toLowerCase().includes('/chat/')) {
            handled = true;
            return;
          }
          if (
            (evt.status === 200 || evt.status === 201) &&
            (evt.statusText.toUpperCase() === 'OK' || evt.statusText === 'Created') &&
            ['POST', 'PATCH', 'PUT', 'DELETE', 'UPDATE'].includes(request.method.toUpperCase()) &&
            !request.url.toUpperCase().includes('IDENTITY')
          ) {
            const requestMethod = request.method.toUpperCase();
            const statusMessage = `${evt.status}-${evt.statusText}`;

            switch (requestMethod) {
              case 'PATCH': {
                const patchResponse = evt.body?.ExceptionMessage || '';
                this.notification.showSuccessToast(`${statusMessage} Updated! ${patchResponse}`);
                break;
              }

              case 'PUT':
                if (evt.url.includes('email')) {
                  this.notification.showSuccessToast(`${statusMessage} Email Sent!`);
                } else if (!headers.get('Silent')) {
                  this.notification.showSuccessToast(`${statusMessage} Updated!`);
                }
                break;

              case 'POST': {
                // console.log('POST 200 response:', evt.body);
                const conflictMsg = evt.body?.message || evt.body?.Message || '';
                const exceptionMsg = evt.body?.ExceptionMessage || '';
                const descMsg = evt.body?.description || '';
                if (conflictMsg === 'Conflict') {
                  // Conflict responses are handled at the component level — suppress generic toast
                } else if (exceptionMsg) {
                  this.notification.showSuccessToast(exceptionMsg, descMsg || conflictMsg || 'Info');
                } else if (descMsg && descMsg.toLowerCase() !== 'success') {
                  this.notification.showSuccessToast(descMsg, 'Success!');
                } else {
                  this.notification.showSuccessToast(`${statusMessage} Success!`);
                }
                break;
              }

              case 'DELETE':
                this.notification.showSuccessToast(`${statusMessage} Deleted!`);
                break;

              case 'UPDATE':
                this.notification.showSuccessToast(`${statusMessage} Updated!`);
                break;

              default:
                this.notification.showSuccessToast(`${statusMessage} Saved!`);
            }
          }

          handled = true;
          return;
        }
      }),
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          // console.log('i am an httpErrorResponse: ', err);
          this.errUrl = err?.url;
          this.errStatus = err?.status;
          this.errStatusText = err?.statusText;
          this.errText = err?.message;
          this.errMessage = err?.message;
          this.errDesc = err?.error?.error || err?.error?.description;
          this.errData = err?.error?.data;

          // for ever changing 400  ... blahhhh
          let data400: any = '';
          if (this.errData) {
            data400 = '<br><br>' + 'Request Data: ' + this.errData;
          }
          // end 400 error reporting text mods

          const errorResponse = (typeof err?.error === 'string')
            ? err.error.split(',').join(' <br>')
            : (err?.error?.message || err?.error?.Message || err?.error?.title || JSON.stringify(err?.error));

          try {
            this.errMsgScreen = this.errStatus + ' - ' + this.errStatusText + '<br><br>' + errorResponse;
            this.errMsgLog = this.errStatus + ' - ' + this.errStatusText + ' - ' + this.errMessage;

            const lastErr = this.lastErrorTrapped;

            // show the error only once for each page - this checks if it fired same within time frame.
            // happens when you have a bunch of gets on same page and it crashes mid stream
            const currErrorDateTime = new Date();
            const lastErrorDateTime = new Date(this.lastErrorDateTime);
            const errorDiffTime = currErrorDateTime.getTime() - lastErrorDateTime.getTime();
            const errorLastPage = this.lastErrorUrl;

            // for testing
            // console.log('diff: ' + errorDiffTime);
            // console.log('last: ' + lastErrorDateTime);
            // console.log('curr: ' + currErrorDateTime);
            // console.log('this err: ' + this.errStatus);
            // console.log('last err: ' + lastErr);

            // 401 will recur for each api call on page - just show them one.
            // 401 initially caught in jwt intercept but it refresh or login it re throws so caught here
            if (this.errStatus === 401 && lastErr === '401' && errorDiffTime <= 1) {
              handled = true;
              return;
            }

            if ([400].includes(this.errStatus)) {
              this.notification.showErrorToastStayOnScreen(this.errDesc + data400, this.errStatus + ' - ' + this.errStatusText);
              this.logIt();
              handled = true;
            } else if ([401].includes(this.errStatus)) {
              if (url.includes('/login')) {
                this.notification.showWarningToast(
                  'Incorrect Username or Password.'
                );
                this.errMsgLog = this.errMsgLog + ' ' + 'Incorrect Username or Password';
                this.logIt();
              } else if (url.includes('/refresh')) {
                this.notification.showWarningToast('Login has expired.');
                this.errMsgLog = this.errMsgLog + ' ' + 'Login has expired';
                this.logIt(); // do not change order - logout clears vars and these need to be there to stop multi notify
                this.authUser.logout(true);
              } else {
                // this.notification.showWarningToast('Login has expired.');
                // this.errMsgLog = this.errMsgLog + ' ' + 'Login has expired';
                // this.logIt(); // do not change order - logout clears vars and these need to be there to stop multi notify
                // this.authUser.logout();
              }
              handled = true;
            } else if ([403].includes(this.errStatus)) {
              this.notification.showErrorToast(this.errMsgScreen);
              this.logIt();
              handled = true;
              // this.authUser.logout();
            } else if ([404].includes(this.errStatus)) {
              // routed to 404 page from app routes via last item in list and ** route
              this.logIt();
              handled = true;
              if (!url.includes('/inventory/dashboard/')) {
                this.router.navigate(['common/error404-page'], {state: this.getErrorState()}).then();
              }
            } else if ([405].includes(this.errStatus)) {
              this.notification.showErrorToast(this.errMsgScreen);
              this.logIt();
              handled = true;
            } else if ([409].includes(this.errStatus)) {
              const serverMsg = (typeof err?.error === 'string' && err.error.trim())
                ? err.error.trim()
                : (err?.error?.message || err?.error?.Message || err?.error?.title || '');
              const serverDesc = err?.error?.description || err?.error?.Description || err?.error?.detail || err?.error?.Detail || '';
              let msg409: string;
              if (serverMsg) {
                msg409 = this.errStatus + ' - ' + serverMsg;
                if (serverDesc && serverDesc !== serverMsg) {
                  msg409 += '<br>' + serverDesc;
                }
              } else {
                msg409 = this.errStatus + ' - ' + 'if deleting this item is use in other dependent records.'
                  + '<br>' + ' Those records must be deleted before you can delete this item.'
                  + ' If adding a column requiring unique is not unique. Change text to be unique.';
              }
              this.notification.showWarningToastStayOnScreen(msg409);

              this.logIt();
              handled = true;
            } else if ([411].includes(this.errStatus)) {
              this.notification.showErrorToast(this.errMsgScreen);
              this.logIt();
              handled = true;
            } else if ([418].includes(this.errStatus)) {
              // UI message and handling at component level since this is the value we use to say a record has changed since pulled
              // each instance will likely be handled differently, so its best to do this one at the calling component.
              // error is re thrown at the end when it is a 418
              handled = true;
            } else if ([500].includes(this.errStatus)) {
              this.logIt();
              if (url.includes('/refresh')) {
                // Expired refresh token returns 500 from identity server — auto logout instead of error page
                this.authUser.logout(true, 'Your session has expired. Please log in again.');
              } else {
                // routed to 500 page from app routes  ** route
                this.router.navigate(['common/error500-page'], {state: this.getErrorState()}).then();
              }
              handled = true;
            } else if ([503].includes(this.errStatus)) {
              // routed to 500 page from app routes via ** route
              this.logIt();
              this.router.navigate(['common/error500-page'], {state: this.getErrorState()}).then();
              handled = true;
            } else if ([0].includes(this.errStatus)) {
              // routed to 500 page from app - web server not answering error
              console.log(
                'Server down or not responding to requests correctly - ' +
                  this.errStatus +
                  ' - ' +
                  this.errStatusText +
                  ' - ' +
                  this.errMessage
              );
              this.logIt();
              this.router.navigate(['common/error500-page'], {state: this.getErrorState()}).then();
              handled = true;
            } else {
              // catches all others not defined above and displays
              this.notification.showErrorToast(this.errMsgScreen);
              this.router.navigate(['common/error500-page'], {state: this.getErrorState()}).then();
              this.logIt();
              handled = true;
            }
          } catch (e) {
            console.log('App error occurred in http message interceptor', e.message);
            this.logIt();
            this.notification.showErrorToast(
              'Some undefined application error occurred.'
            );
          }
        }
        if (handled && [418].includes(this.errStatus)) {
          return throwError(() => err);
        } else {
          // console.log('forwarded error:' + JSON.stringify(err));
          return throwError(() => err);
          // return of (err);
        }
      })
    );
  }

  logIt(): void {
    console.log(this.errMsgLog);
    this.lastErrorTrapped = String(this.errStatus);
    this.lastErrorUrl = this.errUrl;
    this.lastErrorDateTime = new Date().toISOString();
  }

  getErrorState(): object {
    const code = this.errStatus === 0 ? 'Server Unreachable' : String(this.errStatus);
    return {
      errorCode: code,
      errorFromPage: this.errUrl,
      errorDateTime: new Date().toISOString(),
      errorMessage: this.errMsgScreen || this.errMsgLog || ''
    };
  }

}
